import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { LANGUAGE } from "../constants/cookieConsts";
import { getCookie } from "../helpers/other/cookies";
import translationEN from "./locales/en.json";
import translationIT from "./locales/it.json";
import translationSRCyrl from "./locales/sr-Cyrl.json";
import translationSR from "./locales/sr-Latn.json";

const resources = {
  en: { translation: translationEN },
  "sr-Latn": { translation: translationSR },
  "sr-Cyrl": { translation: translationSRCyrl },
  it: { translation: translationIT },
};

const domainLanguageMap = {
  "https://quiz.firebird.rs": "sr-Latn",
  "https://www.quiz.firebird.rs": "sr-Latn",
};

const getFallbackLanguage = () => {
  try {
    const referrer = document.referrer;
    // const currentUrl = window.location.href;
    const currentOrigin = window.location.origin;

    // console.log("referrer:", referrer);
    // console.log("current URL:", currentUrl);
    // console.log("current origin:", currentOrigin);

    // Prioritet referrer > current origin
    if (referrer) {
      const url = new URL(referrer);
      return domainLanguageMap[url.origin] || "en";
    }

    // Ako nema referrera, koristi current origin
    return domainLanguageMap[currentOrigin] || "en";
  } catch (error) {
    console.error("Error detecting fallback language:", error);
  }
  return "en";
};
const fallbackLang = getFallbackLanguage();

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getCookie(LANGUAGE) || fallbackLang,
    fallbackLng: fallbackLang,
    debug: false,
    detection: {
      order: ["queryString", "cookie"],
      cache: ["cookie"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

// i18n
//   .use(Backend)
//   .use(LanguageDetector)
//   .use(initReactI18next)
//   .init({
//     resources,
//     lng: getCookie(LANGUAGE) || getFallbackLanguage(),
//     fallbackLng: getFallbackLanguage(),
//     debug: false,
//     detection: {
//       order: ["queryString", "cookie"],
//       cache: ["cookie"],
//     },
//     interpolation: {
//       escapeValue: false,
//     },
//   });

export default i18n;
